import { useId } from "react"

const script = (id: string) => {
    const callback = () => {
        const KEY = 'store-cookie-consent'
        const ACCEPTED = 'accepted'
        const HIDDEN = 'translate-y-[200%]'

        const consent = localStorage.getItem(KEY)
        const elem = document.getElementById(id)

        if (consent !== ACCEPTED && elem) {
            const accept = elem.querySelector('[data-button-cc-accept]')
            accept &&
                accept.addEventListener('click', () => {
                    localStorage.setItem(KEY, ACCEPTED)
                    elem.classList.add(HIDDEN)
                })
            const close = elem.querySelector('[data-button-cc-close]')
            close && close.addEventListener('click', () => elem.classList.add(HIDDEN))
            elem.classList.remove(HIDDEN)
        }
    }

    addEventListener('scroll', callback, { once: true })
}

export interface Props {
    /** @title Título */
    title?: string
    /**
     * @title Texto
     * @format html
     */
    text?: string
    /**
     * @title Política de privacidade
     */
    policy?: {
        /**
         * @title Texto
         */
        text?: string
        /**
         * @title Link
         */
        link?: string
    }
    /**
     * @title Botões
     */
    buttons?: {
        /**
         * @title Texto do botão de aceitar
         */
        allowText: string
        /**
         * @title Texto do botão de fechar
         */
        cancelText?: string
    }
    layout?: {
        /**
         * @title Posição
         */
        position?: 'Expandido' | 'Esquerda' | 'Centro' | 'Direita'
        /**
         * @title Conteúdo
         */
        content?: 'Tiled' | 'Piled up'
    }
}

const DEFAULT_PROPS = {
    title: 'Cookies',
    text: 'Guardamos estatísticas de visitas para melhorar sua experiência de navegação.',
    policy: {
        text: 'Saiba mais sobre sobre política de privacidade',
        link: '/politica-de-privacidade',
    },
    buttons: {
        allowText: 'Aceitar',
        cancelText: 'Fechar',
    },
    layout: {
        position: 'Expandido',
        content: 'Tiled',
    },
}

function CookieConsent(props: Props) {
    const id = useId()
    const { title, text, policy, buttons, layout } = {
        ...DEFAULT_PROPS,
        ...props,
    }

    return (
        <>
            <div
                id={id}
                className={`
          translate-y-[200%] transition fixed bottom-0 lg:bottom-2 w-screen z-50 lg:flex
          ${layout?.position === 'Esquerda' ? 'lg:justify-start' : ''}
          ${layout?.position === 'Centro' ? 'lg:justify-center' : ''}
          ${layout?.position === 'Direita' ? 'lg:justify-end' : ''}
        `}
            >
                <div
                    className={`
          p-4 mx-4 my-2 flex flex-col gap-4 shadow bg-base-100 rounded border border-base-200 
          ${
                        !layout?.position || layout?.position === 'Expandido'
                            ? 'lg:container lg:mx-auto'
                            : `
            ${layout?.content === 'Piled up' ? 'lg:w-[480px]' : ''}
            ${!layout?.content || layout?.content === 'Tiled' ? 'lg:w-[520px]' : ''}
          `
                    }
          ${!layout?.content || layout?.content === 'Tiled' ? 'lg:flex-row lg:items-end' : ''}
          
        `}
                >
                    <div
                        className={`flex-auto flex flex-col gap-4 ${
                            !layout?.content || layout?.content === 'Tiled' ? 'lg:gap-2' : ''
                        }`}
                    >
                        <h3 className='text-xl'>{title}</h3>
                        {text && (
                            <div className='text-base' dangerouslySetInnerHTML={{ __html: text }} />
                        )}

                        <a href={policy.link} className='text-sm link link-secondary'>
                            {policy.text}
                        </a>
                    </div>

                    <div
                        className={`flex flex-col gap-2 ${
                            !layout?.position || layout?.position === 'Expandido'
                                ? 'lg:flex-row'
                                : ''
                        }`}
                    >
                        <button className='btn' data-button-cc-accept>
                            {buttons.allowText}
                        </button>
                        <button className='btn btn-outline' data-button-cc-close>
                            {buttons.cancelText}
                        </button>
                    </div>
                </div>
            </div>
            <script type='module' dangerouslySetInnerHTML={{ __html: `(${script})("${id}");` }} />
        </>
    )
}

export default CookieConsent
